module.exports = __webpack_public_path__ + "static/media/homeless.2a676611.png";